const EXPORT_FORM_DESCRIPTION_OPTION = {
  label: 'Include a description in the document',
  name: 'headline',
};

export default EXPORT_FORM_DESCRIPTION_OPTION;
